import React, { useMemo } from 'react';
import Card from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/eco-section/card';
import useSanityPermissionsChecker from 'helpers/hooks/useSanityPermissionsChecker';

interface Props {
  data: any;
  customerGroup: any;
}

const MindfullyMadeTastic: React.FC<Props> = ({ data, customerGroup }) => {
  const { checkNestedItemPermission } = useSanityPermissionsChecker();

  // Get cmsData from data (Sanity)
  const fields = data?.cmsData?.dataSource?.fields;
  const columns = fields?.columns || [];

  // Filter columns by permissions
  const filteredCards = useMemo(
    () => columns.filter((card: any) => checkNestedItemPermission(card, customerGroup)),
    [columns, customerGroup, checkNestedItemPermission],
  );

  if (!filteredCards.length) {
    return null;
  }

  return (
    <div className="mb-60 mt-52 flex uppercase">
      <div className="grid grid-cols-1 gap-50 md:grid-cols-3 lg:grid-cols-3">
        {filteredCards.map((card: any, index: number) => {
          const image = card?.image;
          const imageUrl = image?.fields?.file?.url || image?.url || image;

          return (
            <div key={card?._id || card?._system?.base?.id || index}>
              <Card
                image={imageUrl ? { fields: { file: { url: imageUrl } } } : undefined}
                subHeader={card?.subHeader || ''}
                title={card?.title || ''}
                ecoParagraph={card?.ecoParagraph || ''}
                ctaLabel={card?.ctaLabel || ''}
                ctaReference={card?.ctaReference || ''}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MindfullyMadeTastic;
